import { render, staticRenderFns } from "./RightChart1.vue?vue&type=template&id=5b8ba3c6&"
import script from "./RightChart1.vue?vue&type=script&lang=js&"
export * from "./RightChart1.vue?vue&type=script&lang=js&"
import style0 from "./RightChart1.vue?vue&type=style&index=0&id=5b8ba3c6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports